import React, { Component } from "react";
import "../../css/route.css";
import Config from '../../Config';
import {tooltip, format, popover, toInt, getTimeInIST, format_date_only, format_fancy, formatNumber} from '../../Utils';
import {Glyphicon, Table, ButtonToolbar, Button, OverlayTrigger} from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import XLSX from 'xlsx';
import { Form, FormGroup, FormControl, Modal, InputGroup} from 'react-bootstrap';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import {Typeahead} from 'react-bootstrap-typeahead';

import {Constants} from '../../Constants';

//Services
import {UserService} from '../../Services/UserService';
import {ReportService} from '../../Services/ReportService';
import { DeliveryService } from "../../Services/DeliveryService";
import { RouteService } from "../../Services/RouteService";
import { Chip, Tooltip, IconButton, Icon } from "@material-ui/core";

export default class Schedule extends Component {

    constructor(props) {
      super(props);
      this.state = {
        data: [],
        routeRows: [],
        options: [],
        datePickerDate: moment(),
        maxDatePickerDate: moment(),
        routeId: '',
        filterUndelivered: true,
        filterDelivered: true,

        exporting: false,
        show: false,
        modal: {},
        agentList: [],
        selectedAgent: null
      }

      this.handleDateChange = this.handleDateChange.bind(this);
      this.onRouteChange = this.onRouteChange.bind(this);
      this.applyFilter = this.applyFilter.bind(this);
      this.updateRows = this.updateRows.bind(this);
      this.edit = this.edit.bind(this);

      this.onEditClick = this.onEditClick.bind(this);
      this.minus = this.minus.bind(this);
      this.plus = this.plus.bind(this);
      this.handleShow = this.handleShow.bind(this);
      this.handleClose = this.handleClose.bind(this);
      this.props.updateLocation();
    }

    handleClose() {
        this.setState({ show: false });
    }

    handleShow() {
        this.setState({ show: true });
    }

    minus(e, type) {
        e.preventDefault();
        let modal = this.state.modal;
        switch(type){
            case "delivered_count":
                if ( modal.delivered_count > 0 ){
                    --modal.delivered_count;
                    this.setState({modal: modal})
                }
                return;
            case "bottles_returned":
                if ( modal.bottles_returned > 0 ){
                    --modal.bottles_returned;
                    this.setState({modal: modal})
                }
                return;
            default:
                return;
        }
    }

    plus(e, type){
        e.preventDefault();
        let modal = this.state.modal;
        switch(type){
            case "delivered_count":
                if ( modal.delivered_count < parseInt(modal.product_qty, 10) ){
                    ++modal.delivered_count;
                    this.setState({modal: modal})
                }
                return;
            case "bottles_returned":
                    ++modal.bottles_returned;
                    this.setState({modal: modal})
                return;
            default:
                return;
        }
    }

    onEditClick(e){
        e.preventDefault();
        let modal = this.state.modal;
        if(this.state.selectedAgent && modal.delivered_count > 0){
            modal.location = `${this.props.latitude},${this.props.longitude}`;
            modal.delivery_date = moment(new Date()).utc().format(format);
            let body = {rows: [modal]};
            console.log(body);
            this.props.isLoading(true);
            DeliveryService.markDelivery(this.state.selectedAgent.id, body)
            .then(() => {
                this.fetchData(this.state.datePickerDate, this.state.routeId);
                if(this.state.show) this.handleClose();
                this.props.isLoading(false);
                this.props.showSnackBar(`Changed the Delivery status for ${this.state.modal.customer}`  , 'info');
            })
            .catch((error) => {
                this.props.isLoading(false);
                this.props.showSnackBar(`Something went wrong. Please try again later.` , 'error');
            });
        }
    }

    edit(e, report){
        e.preventDefault();
        let agent = this.state.agentList.filter((a) => a.id === report.agent_id);
        this.setState({modal: report, selectedAgent: agent[0]}, () => {this.handleShow()});
    }

    componentWillMount(){
        UserService.getAgentList()
        .then((data) => {
            console.log(data);
            this.setState({agentList: data.users});
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }
    
    componentDidMount(){
        this.props.setTitle('Schedule Report');
        RouteService.getRouteList()
            .then((parsedJSON) => {
                return parsedJSON.routes.map(route => (
                    {
                        id: `${route.id}`,
                        name: `${route.name}`
                    }) 
                )
            })
            .then((data) => {
                let options = data.map(route => route.name);
                console.log(options);
                this.setState({
                    options: options,
                    routeId: options[0]
                });
                this.fetchDate();
            })
            .catch(error => console.log(error));
    }

    fetchDate(){
       ReportService.getReportMax()
        .then((data) => {
            console.log(data.date);
            let d = moment(data.date !== null ? data.date: new Date());
            this.setState({
                //datePickerDate: d,
                maxDatePickerDate: d >= this.state.maxDatePickerDate ? d : this.state.maxDatePickerDate
            });
            this.fetchData(d, this.state.routeId);
        })
        .catch(error => console.log(error));
    }

    onRouteChange(route){
        console.log(route);
        this.setState({routeId: route.value});
        this.fetchData(this.state.datePickerDate, route.value);
    }

    fetchData(date, routeId = this.state.routeId){
        this.props.isLoading(true);
        ReportService.getScheduleReport(date, routeId)
        .then((data) => {
            console.log(data.report);
            this.setState({
                data: data.report
            },() => this.updateRows());
            
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    updateRows(){
        let routeRows = [];
        let filterDelivered = this.state.filterDelivered, filterUndelivered = this.state.filterUndelivered;
        console.log(filterDelivered, filterUndelivered);
        this.state.data.forEach((report) => {
            if((filterDelivered && report.agent)|| (filterUndelivered && !report.agent)){
                routeRows.push(
                    <RouteDetails key={report.id} report={report} edit={this.edit}/>);
            }
           
        });
        this.setState({routeRows: routeRows, message: routeRows.length > 0 ? "" : "No Data available"});
    }

    handleDateChange(date){
        this.setState({
            datePickerDate: date
        });
        this.fetchData(date);
    }

    applyFilter(e){
        e.preventDefault();
        const target = e.target;
        if(target.name === "undelivered") {
            console.log(target.name);
            this.setState({ filterUndelivered : !this.state.filterUndelivered}, () => this.updateRows());
        } else if (target.name  === "delivered") {
            console.log(target.name);
            this.setState({filterDelivered : !this.state.filterDelivered}, () => this.updateRows());
        }
    }

    exportReport = () => {
        this.setState({exporting: true});
        let reportdata = this.state.data;
        if(reportdata && reportdata.length > 0) {
            let sheetname = 'Schedule Report';
            let exportData = [];

            let title = ["Sl No", "Store", "Product", "Issued Qty", "Amount", "Agent name", "Delivered Qty", "Reason", "Delivered date"];
            exportData.push(title);
            let index = 0;
            reportdata.forEach((row) => {
                let r = [++index, row.customer, row.product, row.product_qty, row.total_amount, row.agent ? row.agent : "-", row.delivered_count, row.reason, row.agent ? getTimeInIST(row.delivery_date).format(format_fancy): "-"];
                exportData.push(r);
            });

            if(exportData){
                const wb = XLSX.utils.book_new();
                const wsAll = XLSX.utils.aoa_to_sheet(exportData);
                XLSX.utils.book_append_sheet(wb, wsAll, sheetname );
                XLSX.writeFile(wb, sheetname + ".xlsx");
            }
            this.setState({exporting: false});
        } else {
            this.props.showSnackBar('Nothing to export', 'error');
            this.setState({exporting: false});
        }
    }
    
    render() {
        const options = this.state.options;
        const defaultOption = this.state.routeId;
        const message = this.state.message;
        const propsUndelivered = {active : this.state.filterUndelivered, bsStyle : "primary"};
        const propsDelivered = {active : this.state.filterDelivered, bsStyle : "primary"};
        let d = this.state.datePickerDate;
        let r = this.state.routeId;
        return (
            <div className="Home" style={{marginTop: 32}}>
                <DatePicker
                    selected={this.state.datePickerDate} 
                    onChange={this.handleDateChange}  
                    todayButton={"TODAY"}
                    maxDate={this.state.maxDatePickerDate}
                    withPortal
                    dateFormat={format_date_only}
                    tabIndex={1}
                    title="Select Date"
                    className="datePicker options-margin-top"/>
                <Dropdown className="options-margin-top" options={options} onChange={this.onRouteChange} value={defaultOption} placeholder="Select a route" />
                <ButtonToolbar style={{marginTop: "10px"}}>
                    <Button onClick={(e) => this.fetchData(d, r)}><Glyphicon glyph="refresh"/>&nbsp;Refresh</Button>
                    <Button {...propsUndelivered} name="undelivered" onClick={this.applyFilter}>Undelivered</Button>
                    <Button {...propsDelivered} name="delivered" onClick={this.applyFilter}>Delivered</Button>
                    <span style={{float: "left", marginLeft: "20px", position: "relative", top: "5px"}}><Glyphicon glyph="filter"/><b>Filters Applied:</b> {
                                        (this.state.filterDelivered ? <Chip variant="outlined" color="primary" label="Delivered"/> : "")
                                    }{'  '}
                                    {
                                        (this.state.filterUndelivered ? <Chip variant="outlined" color="primary" label="Undelivered"/> : "")
                                    }
                    </span>
                    <Tooltip title="Export">
                        <IconButton aria-label="export" onClick={this.exportReport} style={{float: 'right'}} disabled={this.state.exporting}>
                            <Icon>save_alt</Icon>
                        </IconButton>
                    </Tooltip>
                </ButtonToolbar>
                {
                    !this.props.loading && 
                    <div className="container">
                        {
                            (this.state.data.length > 0) && 
                            (
                                <div>
                                    <h4 style={{marginBottom: '20px'}}>{this.props.title}</h4>
                                    <Table striped condensed hover responsive>
                                        <thead>
                                            <tr>
                                                <th>Customer</th>
                                                <th>Product</th>
                                                <th>Issued Qty</th>
                                                <th>Total Amount</th>
                                                <th>Agent name</th>
                                                <th>Delivered Qty</th>
                                                {/* <th>Bottles Returned Count</th> */}
                                                <th>Reason</th>
                                                <th>Location</th>
                                                <th>Delivered date</th>
                                                { false && 
                                                    <th>Edit</th>
                                                }
                                            </tr>
                                        </thead>
                                        <tbody style={{textAlign: "left"}}>
                                            {this.state.routeRows}
                                        </tbody>
                                    </Table>
                                </div>
                            )
                        }
                    </div>
                }
                {
                    (message && this.state.data.length === 0) && 
                    (
                        <p style={{color:"red", paddingLeft:"20px"}}>{message}</p>
                    )
                }
                <Modal show={this.state.show} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>{this.state.show ? "Edit Schedule" : ""}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form className="" onSubmit={this.onEditClick}>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroup.Addon>Customer</InputGroup.Addon>
                                    <FormControl
                                        type="text"
                                        value={this.state.modal.customer}
                                        disabled
                                        placeholder="Customer"
                                        name="customer"/>
                                </InputGroup>
                            </FormGroup>
                            {'      '}
                            <FormGroup>
                                <InputGroup>
                                    <InputGroup.Addon>Product</InputGroup.Addon>
                                    <FormControl
                                        type="text"
                                        value={this.state.modal.product}
                                        placeholder="Product"
                                        name="product"
                                        disabled />
                                </InputGroup>
                            </FormGroup>
                            {'      '}
                            <FormGroup>
                                <InputGroup>
                                    <InputGroup.Addon>Requested Qty</InputGroup.Addon>
                                    <FormControl
                                        type="text"
                                        value={this.state.modal.product_qty}
                                        placeholder="Qty"
                                        name="product_qty"
                                        disabled />
                                </InputGroup>
                            </FormGroup>
                            {'      '}
                            <Typeahead
                                id="typeahead-id-schedule-report"
                                onChange={(selected) => {
                                    this.setState({ "selectedAgent": selected[0] });
                                }}
                                options={this.state.agentList}
                                labelKey="name"
                                placeholder="Choose a Agent"
                                clearButton
                                defaultSelected={
                                    this.state.agentList.filter((agent) => agent.id === this.state.modal.agent_id)
                                }
                            />
                            {'      '}
                            <FormGroup>
                                <span style={{marginRight: "19px"}}>Delivered Count:</span>
                                    <Glyphicon style={{marginRight: "10px"}} glyph="minus" onClick={(e) => this.minus(e, "delivered_count")}/>
                                <Button style={{marginRight: "10px", width: "40px"}} disabled>{this.state.modal.delivered_count}</Button>
                                {/* <span style={{marginRight: "10px", border: "1px black solid"}}> </span> */}
                                <Glyphicon style={{marginRight: "10px"}} glyph="plus" onClick={(e) => this.plus(e, "delivered_count")} />
                            </FormGroup>
                            {   this.state.modal.bottled === '1' &&
                                <FormGroup>
                                    <span style={{marginRight: "10px"}}>Bottles Returned: </span>
                                        <Glyphicon style={{marginRight: "10px"}} glyph="minus" onClick={(e) => this.minus(e, "bottles_returned")}/>
                                    <Button style={{marginRight: "10px", width: "40px"}} disabled>{this.state.modal.bottles_returned}</Button>
                                    {/* <span style={{marginRight: "10px", border: "1px black solid"}}> </span> */}
                                    <Glyphicon style={{marginRight: "10px"}} glyph="plus" onClick={(e) => this.plus(e, "bottles_returned")}/>
                                </FormGroup>
                            }
                                <Button type="submit" onClick={this.onEditClick} style={{marginRight: "10px"}}>Save</Button>
                                {this.state.show ? (<Button onClick={this.handleClose}>Close</Button>): ""}
                        </Form>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }

}

class RouteDetails extends Component {

    openGoogle(e, current_location){
        let location = current_location.split(",");
        e.preventDefault();
        window.open(Config.google_url+location[0]+","+location[1], "_blank");
    }
    
    render() {
        const report = this.props.report;
        let details = "Undelivered";
        if(toInt(report.delivered_count) !== toInt(report.product_qty) && report.agent){
            details = report.reason;
        } else if(report.agent) {
            details = "Delivered";
        }
        let away = parseFloat(report.away);
        
        return (
                <OverlayTrigger key={report.id} placement="top" overlay={popover(details)}>
                    <tr className={report.delivered_count === "0" && report.agent ? "danger" : ""}>
                        <td>{report.customer}</td>
                        <td>{report.product}</td>
                        <td>{report.product_qty}</td>
                        <td>{formatNumber(report.total_amount)}</td>
                        <td>{report.agent ? report.agent : "-"}</td>
                        <td>{report.delivered_count}</td>
                        {/* <td>{report.bottles_returned}</td> */}
                        <td>{report.reason}</td>
                        <td>
                            { report.geo_location ? 
                                    <OverlayTrigger placement="bottom" overlay={tooltip("Open Maps")}>
                                        <Glyphicon glyph="map-marker" style={{marginRight: "10px"}} onClick={(e) => this.openGoogle(e, report.geo_location)}>
                                            {report.geo_location}
                                        </Glyphicon>
                                    </OverlayTrigger>
                                    :
                                    ""
                            }
                            {away > 0 ?  <Chip label={`${away}m`} color={ away > 50 ? "secondary" : "primary"} variant={away > 50 ? "default" :"outlined"}/> : <Chip label="Not available" variant="outlined" color="secondary"/>}
                        </td>
                        <td>{report.agent ? getTimeInIST(report.delivery_date).format(format_fancy): "-"}</td>
                        { report.type !== Constants.STORE && 
                            <td>
                                <Glyphicon style={{marginRight: "10px"}} glyph="pencil" onClick={(e) => this.props.edit(e, report)}/>
                            </td>
                        }
                    </tr>
                </OverlayTrigger>
        );
    }
}